import React, { useEffect, useState } from "react";
import Container from "../../../components/shared/container";
import { useOptions } from "../../../hooks/useOptions";
import { GatsbyImage } from "gatsby-plugin-image";
import { getGatsbyImageData } from "../../../utils/utils";

const ContactsSection = () => {
    const faq = useOptions().wpOptions.data.old;

    return (
        <div className="w-full bg-light-gray">
            <Container>
                <section className="font-plex flex flex-col px-7 sm:px-[30px] lg:px-10 pb-[30px] lg:pb-8">
                    <div className="flex flex-col md:flex-row border-[1px] border-dark-blu border-dashed rounded-[20px] my-8 sm:mb-10 p-[15px] overflow-hidden">

                        <div className="w-full md:w-[45%] flex justify-center items-center flex-col font-plex">
                            <GatsbyImage
                                alt={"contact us"}
                                image={getGatsbyImageData(faq.image.localFile)}
                                loading="lazy"
                                className="w-[100px] h-[100px] rounded-full object-cover"
                            />
                            <p className="text-small-14 text-black leading-relaxed">{faq.name}</p>
                            <p className="text-small-14 text-black">{faq.job}</p>
                        </div>

                        <div className="w-full text-center md:flex md:flex-col md:items-center md:justify-center">
                            <p className="text-[34px] font-bold leading-[1.2] text-dark-blu mb-1 lg:mb-2">{faq.title}</p>
                            <div className="text-18 text-black mb-4 md:mb-0" dangerouslySetInnerHTML={{ __html: faq.description }}></div>
                            <div className="text-18 leading-[26px] flex flex-row gap-2 justify-center">
                                <p className="text-black">{faq.email_label}</p>
                                <div className="text-dark-blu hover:text-button-accent-color">
                                    <a href={`mailto:${faq.email}`}>{faq.email}</a>
                                </div>
                            </div>
                        </div>



                    </div>

                    <div className="text-small-14 text-black border-b border-border-color pb-4 lg:pb-1 mb-[10px]" dangerouslySetInnerHTML={{ __html: faq.disclaimer.title }} />
                    <div className="text-small-14 text-black" dangerouslySetInnerHTML={{ __html: faq.disclaimer.description }} />
                </section>
            </Container>
        </div>
    );
};

export default ContactsSection;
